import React from 'react';
import styles from './Footer.module.scss';
import { FOOTER_STRINGS } from '../../shared/constants/strings';

interface FooterProps {
  sidebarExpanded?: boolean;
}

export const Footer: React.FC<FooterProps> = ({ sidebarExpanded = true }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={`${styles.footer} ${sidebarExpanded ? '' : styles.footerCollapsed}`} role="contentinfo">
      <p className={styles.copyright}>{FOOTER_STRINGS.COPYRIGHT(currentYear)}</p>
    </footer>
  );
};

export default Footer;
